/**
 * Componente reutilizable que genera skeleton cards individuales.
 * Usado por SkeletonLoader y NotesSkeletonLoader para evitar duplicación.
 * 
 * @param {Object} props
 * @param {number} props.count - Número de skeleton cards a generar
 */
export default function SkeletonCardItems({ count = 3, itemClassName = '' }) {
  const items = [];
  const itemClasses = `skeleton-grid-item${itemClassName ? ` ${itemClassName}` : ''}`;
  
  for (let i = 0; i < count; i++) {
    items.push(
      <div key={i} className={itemClasses}>
        <div className="skeleton-card">
          <div className="skeleton-card-image-grid"></div>
          <div className="skeleton-card-content-grid">
            <div className="skeleton-line skeleton-line-category"></div>
            <div className="skeleton-line skeleton-line-title-grid"></div>
            <div className="skeleton-line skeleton-line-title-grid"></div>
            <div className="skeleton-line skeleton-line-title-grid short"></div>
            <div className="skeleton-line skeleton-line-date"></div>
          </div>
        </div>
      </div>
    );
  }

  return <>{items}</>;
}
